const maintenancePageIt = {
    "maintenance": {
        "title": "Alessio Mason",
        "description": "Il sito è al momento in manutenzione. Riprova più tardi!"
    }
}

const maintenancePageEn = {
    "maintenance": {
        "title": "Alessio Mason",
        "description": "The website is currently under maintenance. Check back later!"
    }
}

export {maintenancePageIt, maintenancePageEn};